import Link from 'next/link';

import { useTranslation } from '@lichtblick/i18next';
import { OpenInBrowser } from '@lichtblick/icons';
import { Colors } from '@lichtblick/theme';
import { SidesheetItem, GetUserUserPayloadModel } from '@lichtblick/types';

import { SidesheetContainer } from './Sidesheet.styles';

import { Button } from '../../Button';
import { Separator } from '../../Separator';
import { SidesheetSection } from '../SidesheetSection';

export type SidesheetProps = {
  content: SidesheetItem[];
  isQmNavigate?: boolean;
  isShowBtn?: boolean;
  user: GetUserUserPayloadModel;
  workOrderId?: number;
};

export const Sidesheet = ({ content, isQmNavigate, isShowBtn, user, workOrderId }: SidesheetProps) => {
  const { t } = useTranslation();
  const userRoles = user.roles?.map((role) => role.name);
  const shouldSeePM = userRoles
    ? workOrderId && !isQmNavigate && (userRoles.includes('Project Manager') || userRoles.includes('Branch Manager'))
    : false;

  return (
    <SidesheetContainer>
      {content.map((item, idx) => (
        <div key={`sidesheet-${item.type}`}>
          {idx > 0 && <Separator color={Colors.blue[20]} isDecorative orientation="horizontal" />}
          <SidesheetSection isShowBtn={isShowBtn} item={item} />
        </div>
      ))}
      {shouldSeePM && (
        <Link href={`/pm/installation/${workOrderId}/appointments`}>
          <Button isParentSize label={t(`common:showInPmApp`)}></Button>
        </Link>
      )}
      {isQmNavigate && (
        <Link href={`/qm/orders/${workOrderId}/categories`} target="_blank">
          <Button icon={<OpenInBrowser />} label={t('pm:openInQmApp')} />
        </Link>
      )}
    </SidesheetContainer>
  );
};
